import { render } from "./AgentsEdit.vue?vue&type=template&id=4d6d99ce"
import script from "./AgentsEdit.vue?vue&type=script&lang=js"
export * from "./AgentsEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__